export type LinkedinRequestResponse = { status: number; logs?: any[]; text: string; headers?: any };

type LinkedinRequestResponseRaw =
    | { status: false; logs?: any[]; reason?: string; raw?: string; error?: any }
    | LinkedinRequestResponse;

export abstract class LinkedinRequest<TArgs, TResult> {
    constructor(readonly args: TArgs) {}

    abstract createRequest(): {
        fullUrl: string;
        method: string;
        headers: Record<string, string>;
        body: any;
        queryParams: string;
    };

    parseResponse(
        response: LinkedinRequestResponseRaw,
    ): { result: TResult; success: true; logs: any[] } | { error: any; success: false; logs: any[]; reason: string } {
        if (response.status === false) {
            return {
                success: false,
                error: response.error || 'unknown error in extension',
                reason: response.reason || 'unknown reason',
                logs: response.logs || [],
            };
        }
        try {
            const parsed = this.parseInternal(response);
            if (parsed.success) {
                return {
                    result: parsed.result,
                    success: true,
                    logs: response.logs || [],
                };
            } else {
                return {
                    error: (parsed as any)?.error || 'unknown error in parsing',
                    success: false,
                    logs: response.logs || [],
                    reason: 'unknown reason',
                };
            }
        } catch (error) {
            return { error, success: false, logs: response.logs || [], reason: 'parsing error' };
        }
    }

    protected abstract parseInternal(
        response: LinkedinRequestResponse,
    ): { result: TResult; success: true } | { error: any; success: false };
}
